// extracted by mini-css-extract-plugin
export default {"wrap":"preloader_wrap__zRRWk","loaderWrap":"preloader_loaderWrap__aJpLo","loader":"preloader_loader__sNM8S","rotation":"preloader_rotation__xo3HR"};